import React from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'

export interface LoadingDotsProps {
  size?: number
  withText?: boolean
}

const DotFlashing = styled.div.attrs<LoadingDotsProps>((props) => ({
  ...props,
  size: props.size || 10,
  children: <div className="dot-flashing" />,
}))<LoadingDotsProps>`
  .dot-flashing {
    position: relative;
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    border-radius: 50%;
    background-color: var(--blueish-600);
    color: var(--blueish-600);
    animation: dotFlashing 1s infinite linear alternate;
    animation-delay: 0.5s;
  }

  .dot-flashing::before,
  .dot-flashing::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  .dot-flashing::before {
    left: ${({ size }) => `${size * -1.5}px`};
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    border-radius: 50%;
    background-color: var(--blueish-600);
    color: var(--blueish-600);
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
  }

  .dot-flashing::after {
    left: ${({ size }) => `${size * 1.5}px`};
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    border-radius: 50%;
    background-color: var(--blueish-600);
    color: var(--blueish-600);
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: var(--blueish-600);
    }
    50%,
    100% {
      background-color: var(--blueish-50);
    }
  }
`
const LoadingDots = styled.div.attrs<LoadingDotsProps>((props) => ({
  ...props,
  size: props.size || 10,
  children: (
    <>
      <p>
        <Trans i18nKey="Loading" ns="common" />
      </p>
      <DotFlashing size={props.size} />
    </>
  ),
}))<LoadingDotsProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  p {
    margin: 0;
    color: var(--blueish-600);
    font-weight: 500;
    font-size: ${({ size }) => `${size * 3}px`};
    ${({ withText }) => !withText && 'display: none'};
  }

  div {
    margin: 0 ${({ size }) => `${size + size / 2}px`};
    margin-bottom: ${({ size }) => `${size / 3}px`};
    align-self: flex-end;
  }
`
export default LoadingDots
